export const apiHeaderOptions = () => {
  const activeUser = JSON.parse(sessionStorage.getItem('userInfo'));
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer otmmToken ${activeUser?.userDetails.message_digest}`
    }
  };
  return requestOptions;
};

export const apiPostHeaderOptions = () => {
  const activeUser = JSON.parse(sessionStorage.getItem('userInfo'));
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer otmmToken ${activeUser?.userDetails.message_digest}`
    },
    body: JSON.stringify({})
  };
  return requestOptions;
};
